import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getChannelUrl } from '../shared/utils/getChannelUrl';
import { prepareHeaders } from './helpers';

export { getChannelUrl };

export const channelApi = createApi({
  reducerPath: 'channelApi',
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: getChannelUrl(),
    credentials: 'include',
    prepareHeaders,
  }),
  endpoints: () => ({}),
});
